// The environment store
export const env = {
  FLOW: process.env.NEXT_PUBLIC_AUTH_FLOW || '', // SHARED AND REQUIRED PUBLIC
  PATH_PREFIX: process.env.NEXT_PUBLIC_AUTH_PATH_PREFIX || '/auth', // SHARED AND REQUIRED PUBLIC
};

export default env;
